<template>
  <div class="navbar-bookmarks flex items-center">
    <!-- STARRED PAGES - FIRST 10 -->
    <ul class="vx-navbar__starred-pages">
      <draggable
        v-model="starredPagesLimited"
        :group="{name: 'pinList'}"
        class="flex cursor-move">
        <li
          v-for="page in starredPagesLimited"
          :key="page.url"
          class="starred-page" >
          <vx-tooltip
            :text="page.title"
            position="bottom"
            delay=".3s">
            <div
              v-if="page.iconPack === 'custom' && page.icon === 'square'"
              style="width: 35px; height: 35px;"
              class="cursor-pointer p-2">
              <svg
                class="square-icon cursor-pointer"
                data-testid="square-logo" width="21" height="21" viewBox="0 0 48 48" role="img" aria-hidden="false" aria-label="Square Dashboard">
                <g fill="currentColor" fill-rule="evenodd">
                  <path d="M38.9085938,36.3832764 C38.9085938,37.7779998 37.7772516,38.9078455 36.3840246,38.9078455 L11.5049719,38.9078455 C10.1102484,38.9078455 8.97890625,37.7779998 8.97890625,36.3832764 L8.97890625,11.5042236 C8.97890625,10.1095002 10.1102484,8.97965449 11.5049719,8.97965449 L36.3840246,8.97965449 C37.7772516,8.97965449 38.9085938,10.1095002 38.9085938,11.5042236 L38.9085938,36.3832764 Z M39.8843016,0.000748242187 L8.00319844,0.000748242187 C3.58408008,0.000748242187 0,3.58333184 0,8.0024502 L0,39.8850498 C0,44.3041682 3.58408008,47.8867518 8.00319844,47.8867518 L39.8843016,47.8867518 C44.3034199,47.8867518 47.8875,44.3041682 47.8875,39.8850498 L47.8875,8.0024502 C47.8875,3.58333184 44.3034199,0.000748242187 39.8843016,0.000748242187 L39.8843016,0.000748242187 Z"></path>
                  <path d="M28.4332031,17.9578125 L19.4542969,17.9578125 C18.6521812,17.9578125 17.9578125,18.6506848 17.9578125,19.4542969 L17.9578125,28.4332031 C17.9578125,29.2383117 18.6521812,29.9296875 19.4542969,29.9296875 L28.4332031,29.9296875 C29.2338223,29.9296875 29.9296875,29.2383117 29.9296875,28.4332031 L29.9296875,19.4542969 C29.9296875,18.6506848 29.2338223,17.9578125 28.4332031,17.9578125"></path>
                </g>
              </svg>
            </div>

            <feather-icon
              v-else
              :svgClasses="['h-6 w-6 stroke-current', textColor]"
              class="p-2 cursor-pointer"
              :icon="page.icon"
              @click="$router.push(page.url).catch(() => {})" />
          </vx-tooltip>
        </li>
      </draggable>
    </ul>

    <!-- STARRED PAGES MORE -->
    <div
      v-if="starredPagesMore.length"
      class="vx-navbar__starred-pages--more-dropdown">
      <vs-dropdown
        vs-custom-content
        vs-trigger-click class="cursor-pointer">
        <feather-icon
          icon="ChevronDownIcon"
          svgClasses="h-4 w-4"
          class="cursor-pointer p-2"></feather-icon>
        <vs-dropdown-menu>
          <ul class="vx-navbar__starred-pages-more--list">
            <draggable
              v-model="starredPagesMore"
              :group="{name: 'pinList'}"
              class="cursor-move">
              <li
                v-for="page in starredPagesMore"
                :key="page.url"
                class="starred-page--more flex items-center cursor-pointer"
                @click="$router.push(page.url).catch(() => {})">
                <svg
                  v-if="page.iconPack === 'custom' && page.icon === 'square'"
                  class="square-icon ml-2 mr-1"
                  data-testid="square-logo"
                  width="17"
                  height="17"
                  viewBox="0 0 48 48"
                  role="img"
                  aria-hidden="false"
                  aria-label="Square Dashboard">
                  <g fill="currentColor" fill-rule="evenodd">
                    <path d="M38.9085938,36.3832764 C38.9085938,37.7779998 37.7772516,38.9078455 36.3840246,38.9078455 L11.5049719,38.9078455 C10.1102484,38.9078455 8.97890625,37.7779998 8.97890625,36.3832764 L8.97890625,11.5042236 C8.97890625,10.1095002 10.1102484,8.97965449 11.5049719,8.97965449 L36.3840246,8.97965449 C37.7772516,8.97965449 38.9085938,10.1095002 38.9085938,11.5042236 L38.9085938,36.3832764 Z M39.8843016,0.000748242187 L8.00319844,0.000748242187 C3.58408008,0.000748242187 0,3.58333184 0,8.0024502 L0,39.8850498 C0,44.3041682 3.58408008,47.8867518 8.00319844,47.8867518 L39.8843016,47.8867518 C44.3034199,47.8867518 47.8875,44.3041682 47.8875,39.8850498 L47.8875,8.0024502 C47.8875,3.58333184 44.3034199,0.000748242187 39.8843016,0.000748242187 L39.8843016,0.000748242187 Z"></path>
                    <path d="M28.4332031,17.9578125 L19.4542969,17.9578125 C18.6521812,17.9578125 17.9578125,18.6506848 17.9578125,19.4542969 L17.9578125,28.4332031 C17.9578125,29.2383117 18.6521812,29.9296875 19.4542969,29.9296875 L28.4332031,29.9296875 C29.2338223,29.9296875 29.9296875,29.2383117 29.9296875,28.4332031 L29.9296875,19.4542969 C29.9296875,18.6506848 29.2338223,17.9578125 28.4332031,17.9578125"></path>
                  </g>
                </svg>

                <feather-icon
                  v-else
                  class="ml-2 mr-1"
                  :icon="page.icon"
                  :svgClasses="['h-5 w-5 stroke-current', textColor]"/>
                <span class="px-2 pt-2 pb-1">{{ page.title }}</span>
              </li>
            </draggable>
          </ul>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>

    <div class="bookmark-container">
      <feather-icon
        icon="StarIcon"
        :svgClasses="['stoke-current text-warning', textColor]"
        class="cursor-pointer p-2"
        @click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown" />
      <div
        v-if="showBookmarkPagesDropdown"
        v-click-outside="outside"
        class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4">
        <vx-auto-suggest
          ref="bookmarkAutoSuggest"
          :autoFocus="true"
          :data="navbarSearchAndPinList"
          :initalData="{pages: autoSuggestInitialData}"
          :searchLimit="5"
          placeholder="Explore GrapePerks"
          inputClassses="w-full"
          show-action
          show-pinned
          hideGroupTitle
          background-overlay
          @input="hnd_search_query_update"
          @selected="selected">

          <!-- Pages Suggestion -->
          <template v-slot:pages="{ suggestion }">
            <div class="flex items-center justify-between">
              <div class="flex items-end leading-none py-1">
                <svg
                  v-if="suggestion.iconPack === 'custom' && suggestion.icon === 'square'"
                  class="square-icon mr-4"
                  data-testid="square-logo"
                  width="17"
                  height="17"
                  viewBox="0 0 48 48"
                  role="img"
                  aria-hidden="false"
                  aria-label="Square Dashboard">
                  <g fill="currentColor" fill-rule="evenodd">
                    <path d="M38.9085938,36.3832764 C38.9085938,37.7779998 37.7772516,38.9078455 36.3840246,38.9078455 L11.5049719,38.9078455 C10.1102484,38.9078455 8.97890625,37.7779998 8.97890625,36.3832764 L8.97890625,11.5042236 C8.97890625,10.1095002 10.1102484,8.97965449 11.5049719,8.97965449 L36.3840246,8.97965449 C37.7772516,8.97965449 38.9085938,10.1095002 38.9085938,11.5042236 L38.9085938,36.3832764 Z M39.8843016,0.000748242187 L8.00319844,0.000748242187 C3.58408008,0.000748242187 0,3.58333184 0,8.0024502 L0,39.8850498 C0,44.3041682 3.58408008,47.8867518 8.00319844,47.8867518 L39.8843016,47.8867518 C44.3034199,47.8867518 47.8875,44.3041682 47.8875,39.8850498 L47.8875,8.0024502 C47.8875,3.58333184 44.3034199,0.000748242187 39.8843016,0.000748242187 L39.8843016,0.000748242187 Z"></path>
                    <path d="M28.4332031,17.9578125 L19.4542969,17.9578125 C18.6521812,17.9578125 17.9578125,18.6506848 17.9578125,19.4542969 L17.9578125,28.4332031 C17.9578125,29.2383117 18.6521812,29.9296875 19.4542969,29.9296875 L28.4332031,29.9296875 C29.2338223,29.9296875 29.9296875,29.2383117 29.9296875,28.4332031 L29.9296875,19.4542969 C29.9296875,18.6506848 29.2338223,17.9578125 28.4332031,17.9578125"></path>
                  </g>
                </svg>
                <feather-icon
                  v-else
                  :icon="suggestion.icon"
                  svgClasses="h-5 w-5"
                  class="mr-4" />
                <span class="mt-1">{{ suggestion.title }}</span>
              </div>
              <feather-icon
                icon="StarIcon"
                :svgClasses="[
                  {'text-warning': suggestion.marked}, 'h-5 w-5 stroke-current mt-1',
                ]"
                @click.stop="actionClicked(suggestion)" />
            </div>
          </template>

        </vx-auto-suggest>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    navbarColor: {
      type: String,
      default: '#fff',
    },
  },
  components: {
    draggable,
    VxAutoSuggest,
  },
  data() {
    return {
      showBookmarkPagesDropdown: false,
    };
  },
  computed: {
    ...mapGetters({
      navMenuItemsByPermissionsLineal: 'navMenuItemsByPermissionsLineal',
      userMarkers: 'auth/markers',
    }),
    navMenuItemsMarkers() {
      return this.navMenuItemsByPermissionsLineal.map((item) => ({
        ...item,
        marked: this.userMarkers.includes(item.slug),
      }));
    },
    navbarSearchAndPinList() {
      return {
        pages: {
          key: 'title',
          data: this.navMenuItemsMarkers,
        },
      };
    },
    starredPages() {
      return this.userMarkers.map(
        (marker) => this.navMenuItemsMarkers.find((item) => item.slug === marker),
      );
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.updateUserMarkers(list.concat(this.starredPagesMore).map((item) => item.slug));
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.updateUserMarkers(this.starredPagesLimited.concat(list).map((item) => item.slug));
      },
    },
    textColor() {
      return { 'text-white': this.$store.state.mainLayoutType === 'vertical' && this.navbarColor != (this.$store.state.theme === 'dark' ? '#10163a' : '#fff') };
    },
    actualPage() {
      return this.navMenuItemsMarkers.find(
        (navMenuItem) => navMenuItem
          && navMenuItem.url
          && (navMenuItem.url === this.$route.fullPath || navMenuItem.url === this.$route.path),
      );
    },
    autoSuggestInitialData() {
      return [
        this.actualPage,
        ...this.starredPages.filter((page) => page.slug !== this.actualPage.slug),
      ];
    },
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown) {
        this.showBookmarkPagesDropdown = false;
      }
    },
  },
  methods: {
    ...mapActions({
      updateUserMarker: 'auth/updateUserMarker',
      updateUserMarkers: 'auth/updateUserMarkers',
    }),
    selected(obj) {
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', false);
      this.showBookmarkPagesDropdown = false;
      this.$router.push(obj.pages.url).catch(() => {});
    },
    actionClicked(item) {
      this.updateUserMarker(item);
    },
    outside() {
      this.showBookmarkPagesDropdown = false;
    },
    hnd_search_query_update(query) {
      // Show overlay if any character is entered
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', !!query);
    },
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        const { bubble } = binding.modifiers;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener('click', handler);
      },

      unbind(el) {
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
};

</script>
